import { render, staticRenderFns } from "./ScreenshotModal.vue?vue&type=template&id=20cc90bc"
import script from "./ScreenshotModal.vue?vue&type=script&lang=js"
export * from "./ScreenshotModal.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotModal.vue?vue&type=style&index=0&id=20cc90bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports